import { mapState } from "vuex";

export default {
    data() {
        return {
            sliderServiceIcons: {
                slidesPerView: 'auto',
                pagination: {
                    el: ".js-icons-pag",
                    clickable: true
                },
            }
        }
    },
    computed: {
        ...mapState('mobile', ['isMobile']),
    },
    methods: {

    }
};



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/service-icons/component.js